<template>
  <Card
    hasNoBorder
  >
    <HeadingSmall :class="$style.marginBottom">
      {{ headerTitle }}
    </HeadingSmall>
    <ParagraphBody>
      <div
        v-for="(row, index) in fields"
        :key="index"
      >
        <div v-if="(row.type === 'object') || (row.type === 'array')">
          <div
            v-if="row.value.length"
            :class="$style.marginTop"
          >
            {{ row.label }} :
          </div>
          <ul
            v-for="(subRow, subIndex) in row.value"
            :key="subIndex"
            :class="$style.listItem"
          >
            <li v-if="subRow.type === 'string'">
              {{ subRow.label }} : {{ subRow.value }}
            </li>
            <li v-if="subRow.type === 'object'">
              <ul
                v-for="(subSubRow, subSubIndex) in subRow.value"
                :key="subSubIndex"
              >
                <li v-if="subSubRow.type === 'string'">
                  {{ subSubRow.label }} : {{ subSubRow.value }}
                </li>
                <li v-else>
                  {{ subSubRow }}
                </li>
              </ul>
            </li>
            <li v-if="subRow.type === 'array'">
              {{ subRow }}
            </li>
          </ul>
        </div>
        <div v-else>
          <div v-if="row.value">
            {{ row.label }} : {{ row.value }}
          </div>
        </div>
      </div>
    </ParagraphBody>
  </Card>
</template>

<script>
import {
  Card,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import AndroidDeviceMixin from 'client/systems/AndroidDeviceMixin';

export default {
  name: 'AndroidDeviceSectionInfo',

  components: {
    Card,
    HeadingSmall,
    ParagraphBody,
  },

  mixins: [AndroidDeviceMixin],

  mounted() {
    this.createFields();
  },
};
</script>

<style module scoped>
.listItem {
  margin: 0.063rem;
  padding-left: var(--jc-spacer-medium);
}

.marginBottom {
  margin-bottom: var(--jc-spacer-medium) !important;
}

.marginTop {
  margin-top: var(--jc-spacer-medium);
}
</style>
